require('../../modules/es.typed-array.uint8-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./node_modules/jspdf/node_modules/core-js/es/typed-array/uint8-array.js
// module id = VpCL
// module chunks = 3